import { render, staticRenderFns } from "./create.vue?vue&type=template&id=1f872be4"
import script from "./create.vue?vue&type=script&lang=js"
export * from "./create.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/private/workspaces/smart-life/smart-life-admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1f872be4')) {
      api.createRecord('1f872be4', component.options)
    } else {
      api.reload('1f872be4', component.options)
    }
    module.hot.accept("./create.vue?vue&type=template&id=1f872be4", function () {
      api.rerender('1f872be4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/goods/point/create.vue"
export default component.exports